import { useEffect, useState } from 'react'

export const useClientHost = () => {
  const [host, setHost] = useState('')
  useEffect(() => {
    const { location } = window
    setHost(`${location.protocol}//${location.host}`)
  }, [])

  return host
}
